import { useApp } from '../../../../app/AppContext.jsx'

import { i18n } from '../../../../shared/i18n/i18n.js'
import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { DEFAULT_MONETARY_OBLIGATIONS_HTML } from '../../constants/additionalInfoDefaults.js'

import { Documents } from '../../../../shared/ui/icons/Documents.jsx'
import { Modal } from '../../../../shared/ui/Modal/index.js'

import styles from './MonetaryObligationsModal.module.scss'

/**
 * MonetaryObligationsModal — displays additional monetary obligations for a product.
 *
 * Content priority:
 *   1. `panelSettings.additional_unit_information.additional_monetary_obligations.description.text_html`
 *   2. Locale-based fallback from `DEFAULT_MONETARY_OBLIGATIONS_HTML` (`pl` / `en`)
 *
 * HTML source is operator-controlled CMS content, not end-user input.
 *
 * @param {object}     props
 * @param {boolean}    props.isOpen
 * @param {() => void} props.onClose
 */
export function MonetaryObligationsModal({ 
  isMobile,
  isOpen, 
  onClose 
}) {
  const { t } = useI18n()
  const { panelSettings } = useApp()

  const cmsHtml =
    panelSettings?.additional_unit_information
      ?.additional_monetary_obligations
      ?.description
      ?.text_html || null

  const localeKey = i18n.locale?.startsWith('en') ? 'en' : 'pl'
  const fallbackHtml =
    DEFAULT_MONETARY_OBLIGATIONS_HTML[localeKey] ?? DEFAULT_MONETARY_OBLIGATIONS_HTML.pl

  const html =
    cmsHtml && cmsHtml.trim().length > 0
      ? cmsHtml
      : fallbackHtml

  const headingIconSize = isMobile ? '2em' : '1.2em'

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel={t('product.obligations_modal_title')}
    >
      <Modal.Header onClose={onClose} closeLabel={t('common.close')}>
        <span className={styles.heading}>
          <Documents 
            width={headingIconSize}
            height={headingIconSize}
          />
          {t('product.obligations_modal_title')}
        </span>
      </Modal.Header>
      <Modal.Content>
        <div className={styles.obligationsPane}>
          <div
            className={styles.htmlContent}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </Modal.Content>
    </Modal>
  )
}
